import { extractApiErrorMessage } from '../../../Utils/apiErrorUtils';

export interface InvoiceSearchErrorResult {
  message: string;
  errorCode?: string;
}

export function extractInvoiceSearchError(error: unknown): InvoiceSearchErrorResult {
  const fallback = 'Nie udało się pobrać listy faktur. Spróbuj ponownie później.';
  if (!error || typeof error !== 'object') {
    return { message: fallback };
  }

  const errorRecord = error as { data?: unknown };
  const data = errorRecord.data;

  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const dataRecord = data as { errorCode?: unknown };
    const errorCode = typeof dataRecord.errorCode === 'string' ? dataRecord.errorCode : undefined;
    const message = extractApiErrorMessage(error, fallback);
    return { message, errorCode };
  }
  return { message: extractApiErrorMessage(error, fallback) };
}
